import React from 'react'
import { ThemeProvider } from '@material-ui/core'
import { unstable_createMuiStrictModeTheme } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import './styles.css'

const theme = unstable_createMuiStrictModeTheme()

export default () => {
    return (
        <div className='doubtsAll'>
            <header>Dúvid@s</header>
            <div className='doubtsBody'>
                <div className='doubtsPanel'>
                    <ThemeProvider theme={theme}>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                1 - Como faço minha inscriç@o?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div>
                                    Você pode fazer sua inscrição no link:&nbsp;
                            <span className='doubtsLink' onClick={() => window.open('https://forms.gle/7MmTfushGUhduED5A')}>Inscrição da Semana do Meio Ambiente 2020</span>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                2 - Qual o v@lor da inscriç@o?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                A participação online na Semana do Meio Ambiente 2020 do IFPB, Campus Cajazeiras é 100% gratuita. Só precisa realizar a sua inscrição para participar de toda aprogramação do evento
                    </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                3 - Como f@ço para escolher a @tivid@de?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                Você poderá escolher qualquer atividade de acordo com o seu interesse pela temática, mas lembre-se: SOMENTE SERÃO   CERTIFICADOS aqueles que entrarem e participarem em pelo menos 2 atividades transmitidas pelo Meet no dia 04 e consequentemente no dia 05 e, ao final da atividade, responder o formulário que atestará a presença do participante
                    </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                4 - Vou receber certific@do?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div>
                                    Vai sim, para isso é necessário se inscrever no site:&nbsp;
                            <span className='doubtsLink' onClick={() => window.open('https://forms.gle/7MmTfushGUhduED5A')}>Inscrição da Semana do Meio Ambiente 2020</span>&nbsp;
                            e observar os links para realizar o check-in das atividades de seu interesse. Ao final da atividade, os moderadores fornecerão um formulário específico que deverá ser preenchido para atestar a presença do participante.Para o certificado de participação é NECESSÁRIO ASSISTIR, no mínimo, 2 webinars na quinta (04/06/2020) e 2 atividades (webinars, oficinas e cine debate) propostas na sexta (05/06/2020). Concluído o evento a comissão enviará o certificado para o e-mail cadastrado no ato da inscrição, em até 15 dias.
                            </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                5 - Qu@l será a plataform@ de transmiss@o?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                Dependerá da atividade: webinars, oficinas e cine debate serão disponibilizados os links do Meet para transmissão. As lives serão transmitidas pelo Instagram, no perfil @ifpbcznaveia, um dos projetos de extensão do campus, de natureza comunicativa
                    </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                6 - Não consigo @ssistir as @tividades na hor@ que acontecem. Tem outro horário disponível?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div>As atividades acontecerão no horário agendado ao vivo, mas ficarão disponíveis no&nbsp;<span className='doubtsLink' onClick={() => window.open('https://is.gd/SemanaMeioAmbiente')}>canal do Youtube</span>&nbsp;após a conclusão da transmissão. Porém não enviaremos certificado de participação para visualizações posteriores</div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                7 - Quem poder@ p@rticip@r?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                Você está convidado, bem como todos os interessados em discutir e aprender mais sobre natureza, sociedade e pandemia
                    </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                8-Como ser@o os concursos?
                    </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div>
                                    Para obter informações sobre os concursos é importante que leia atentamente o Regulamento do I Concurso Ambiental disponível no formulário de inscrição ou no&nbsp;
                                    <span className='doubtsLink' onClick={() => window.open('https://drive.google.com/file/d/1no3izohhfQT7zYeAIYZQ9GmTLEyv-qWH/view')}>regimento do concurso</span>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </ThemeProvider>
                </div>
            </div>
        </div>
    )
}